"use strict";

var objectAssign = require('object-assign');
module.exports = function (blocks) {
  return blocks.map(function (block) {
    if (block._key) {
      return block;
    }
    return objectAssign({
      _key: getStaticKey(block)
    }, block);
  });
};
function getStaticKey(item) {
  return checksum(JSON.stringify(item)).toString(36).replace(/[^A-Za-z0-9]/g, '');
}
/* eslint-disable no-bitwise */

function checksum(str) {
  var hash = 0;
  var strlen = str.length;
  if (strlen === 0) {
    return hash;
  }
  for (var i = 0; i < strlen; i++) {
    hash = (hash << 5) - hash + str.charCodeAt(i);
    hash &= hash; // Convert to 32bit integer
  }
  return hash;
}
/* eslint-enable no-bitwise */